export const NotificationTypeEnum = {
  HOST: 'HOST',
  TRAIL: 'TRAIL',
  ASSIGNMENT: 'ASSIGNMENT'
}

export const NotificationActionEnum = {
  PROGRESSION: 'PROGRESSION',
  SEVERITY_CHANGE: 'SEVERITY_CHANGE',
  ASSIGNMENT_CHANGE: 'ASSIGNMENT_CHANGE',
  STATUS_CHANGE: 'STATUS_CHANGE'
}

export const NotificationCategoryEnum = {
  LOW_MED: 'LOW_MED',
  LOW_HIGH: 'LOW_HIGH',
  MED_HIGH: 'MED_HIGH'
}



// WEBPACK FOOTER //
// ./src/constants/notification.constants.js